<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.content}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="data.buttonClick(data.metadata)" color="primary">{{data.buttonActionYes}}</button>
  <button mat-button mat-dialog-close>{{data.buttonActionNo}}</button>
</div>